import request from './request'

export function listStoppageReason(data) {
  return request.post('/mes/stoppage-reasons/list', data)
}
export function selectStoppageReason() {
  return request.get('/mes/stoppage-reasons/select')
}
export function getStoppageReason(id) {
  return request.get('/mes/stoppage-reasons/' + id)
}
export function saveStoppageReason(data) {
  return request.post('/mes/stoppage-reasons', data)
}
export function updateStoppageReason(data) {
  return request.post('/mes/stoppage-reasons/update', data)
}
export function deleteStoppageReason(ids) {
  return request.post('/mes/stoppage-reasons/delete', ids)
}
